/* eslint-disable import/no-cycle */

'use-strict';

import angular from 'angular';
import { RootScope } from '../../app.config';
import { Role, Subsidiary, User } from '../../src/app/@shared-types/user';
import { LoginResult } from '../../src/app/@types/login';
import { UserRole } from '../../src/app/@types/user';
import { UsersAPIService } from '../api/users-api.service';
import { EssentialAppConfig } from '../../src/app/@shared-types/config';
import { ExternalCompany } from '../../src/app/@shared-types/user/external';

export class UsersService {
  private $rootScope: RootScope;

  private usersApiService: UsersAPIService;

  constructor(
    $rootScope: RootScope,
    usersApiService: UsersAPIService,
  ) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.usersApiService = usersApiService;
  }

  /** Returns the main `Subsidiary` of the current user */
  public getMainSubsidiary = (): Subsidiary | null => {
    const currentSubsidiary = this.currentUser()?.mainSubsidiary;
    if (currentSubsidiary) {
      const config = this.$rootScope.globals.config as EssentialAppConfig;
      const { subsidiaries } = config;
      const subsidiary = subsidiaries?.find((s) => s.id === currentSubsidiary);

      if (subsidiary) return subsidiary;
    }

    return null;
  };

  public currentUserAdmin = (): boolean => this.$rootScope.globals.currentUser?.isAdmin || false;

  public currentUserId = (): number => this.$rootScope.globals.currentUser?.id || -1;

  public currentUser = (): LoginResult['userDetails'] | null => this.$rootScope.globals.currentUser || null;

  public getNameOfCurrentUser = (): string => `${this.currentUser()?.firstName} ${this.currentUser()?.lastName}`;

  public getNameOfUser = (id: number, defaultName?: string): string => {
    const user: any = this.getUserFromId(id);
    if (!user) return defaultName || '';
    return `${user.first_name} ${user.last_name}`;
  };

  public getUserFromId = (userId: number): User | null => {
    if (this.$rootScope.globals.userAccounts) {
      const user = (this.$rootScope.globals.userAccounts as any)
        .filter((u: any) => u.id === userId);
      if (user.length > 0) return user[0];
    }
    return null;
  };

  public getUsers = (): User[] => this.$rootScope.globals.userAccounts as User[];

  public getUserFilter = (): { [id: number]: string } => {
    const users: { [id: number]: string } = {};

    this.getUsers()
      .forEach((u) => {
        users[u.id] = `${u.first_name} ${u.last_name}`;
      });

    return users;
  };

  public getUsersForFilter = (): { [key: number]: string } => {
    const users = this.getUsers();
    const returnUsers: { [key: number]: string } = {};

    users.forEach((u) => {
      returnUsers[u.id] = `${u.first_name} ${u.last_name}`;
    });

    return returnUsers;
  };

  public getRolesOfCurrentUser = (): UserRole[] => this.$rootScope.globals.currentUser?.roles || [];

  public getRoles = (): Promise<Role[]> => this.usersApiService.getRoles();

  public userIsExternal = (): boolean => this.currentUser()?.externalUser || false;

  public getExternalCompanyOfUser = (): string | null => this
    .currentUser()?.externalCompany || null;

  /** Returns a list of all external companies. */
  public getExternalCompanies = (): ExternalCompany[] => {
    const { externalCompanies } = this.$rootScope.globals;
    return externalCompanies || [];
  };
}

export default angular.module('services.usersService', [])
  .service('usersService', UsersService)
  .name;
